<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Дополнительное описание</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Включено
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="description.enabled" />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Заголовок на кнопке
                            </CCol>
                            <CCol sm="9">
                                <CInput       
                                    v-model="description.title"
                                    placeholder="" />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Текст перед блоками
                            </CCol>
                            <CCol sm="9">
                                <CTextarea            
                                    v-model="description.text"
                                    placeholder="" />
                            </CCol>
                        </CRow>
                        
                        <CRow>
                            <CCol sm="12" class="mb-4 text-right">
                                <CButton
                                    color="primary"
                                    @click="addBlock">Добавить блок</CButton>
                            </CCol>
                        </CRow>

                        <template v-for="(block, index) in description.blocks">
                            <CCard :key="`block-${ index }`">
                                <CCardBody>
                                    <CRow>
                                        <CCol
                                            tag="label"
                                            class="col-form-label">
                                            Тип блока<br>
                                            <CSelect
                                                :options="blockTypes"
                                                :value.sync="block.type"
                                                placeholder="Выберите тип"
                                            />
                                        </CCol>
                                        <CCol
                                            tag="label"
                                            class="col-form-label">
                                            Заголовок<br>
                                            <CInput           
                                                v-model="block.title"
                                                placeholder="" />
                                        </CCol>
                                        <CCol
                                            v-if="block.type === 'toggle'"
                                            tag="label"
                                            class="col-form-label">
                                            Изначально в раскрытом виде<br>
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="block.opened" />
                                        </CCol>
                                        <CCol sm="2" class="d-flex align-items-center justify-content-end">
                                            <CButton
                                                color="danger"
                                                @click="removeBlock(index)">Удалить блок</CButton>
                                        </CCol>
                                    </CRow>
                                    <CCard>
                                        <CCardBody>
                                            <template v-for="(line, lindex) in block.list">
                                                <CRow :key="`block-${ index }-list-${ lindex }`">
                                                    <CCol
                                                        v-if="['main', 'toggle', 'permitions'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Основной текст<br>
                                                        <CTextarea            
                                                            v-model="line.title"
                                                            placeholder="" />
                                                    </CCol>
                                                    <CCol
                                                        v-if="['main', 'toggle', 'permitions'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Дополнительный текст<br>
                                                        <CTextarea            
                                                            v-model="line.text"
                                                            placeholder="" />
                                                    </CCol>
                                                    <CCol
                                                        v-if="['toggle'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Цена<br>
                                                        <CInput           
                                                            v-model="line.price"
                                                            placeholder="" />
                                                    </CCol>
                                                    <CCol
                                                        v-if="['faq'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Вопрос<br>
                                                        <CTextarea            
                                                            v-model="line.question"
                                                            placeholder="" />
                                                    </CCol>
                                                    <CCol
                                                        v-if="['faq'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Ответ<br>
                                                        <CTextarea            
                                                            v-model="line.answer"
                                                            placeholder="" />
                                                    </CCol>
                                                    <CCol
                                                        v-if="['faq'].indexOf(block.type) >= 0"
                                                        tag="label"
                                                        class="col-form-label">
                                                        Изначально в раскрытом виде<br>
                                                        <CSwitch
                                                            color="dark"
                                                            shape="pill"
                                                            variant="opposite"
                                                            :checked.sync="line.opened" />
                                                    </CCol>
                                                    <CCol sm="1" class="d-flex align-items-center justify-content-end">
                                                        <CButton
                                                            color="danger"
                                                            @click="removeBlockLine(index, lindex)">Удалить</CButton>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <CRow>
                                                <CCol sm="12" class="text-right">
                                                    <CButton
                                                        color="primary"
                                                        @click="addBlockLine(index)">Добавить строку</CButton>
                                                </CCol>
                                            </CRow>
                                        </CCardBody>
                                    </CCard>
                                </CCardBody>
                            </CCard>
                        </template>

                        <CRow v-if="description.blocks.length">
                            <CCol sm="12" class="text-right">
                                <CButton
                                    color="primary"
                                    @click="addBlock">Добавить блок</CButton>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <!-- <CButton
                        v-if="description.id"
                        color="danger"
                        class="mr-3"
                        @click="remove">Удалить</CButton> -->
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import PromoCovers from '@/components/promo-covers/PromoCovers';
import { CInput } from '@coreui/vue';
import { BUSINESS_TYPE } from '../../utils/order';

    export default {
        name: 'AdditonalEdit',

        components: {
            RestaurantsTabLinks,
            TimeSlotsUpdate,
            PromoCovers,
        },

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
            categoryId: {
                type: Number,
                default: null
            },
        },

        data() {
            return {
                blockTypes: [
                    {
                        value: 'main',
                        label: 'Основной блок'
                    },
                    {
                        value: 'toggle',
                        label: 'Раскрывающийся блок'
                    },
                    {
                        value: 'permitions',
                        label: 'Блок с запретами'
                    },
                    {
                        value: 'faq',
                        label: 'Ответы на вопросы'
                    },
                ],
                description: {
                    entity_type: null,
                    entity_id: null,
                    place: 'entity',
                    category_id: null,
                    title: '',
                    text: '',
                    blocks: [],
                    enabled: true
                },
            };
        },

        computed: {
        },

        async mounted() {
            this.description = {
                ...this.description,
                entity_type: this.entityType,
                entity_id: this.entityId,
                place: this.categoryId ? 'category' : 'entity',
                category_id: this.categoryId ? +this.categoryId : null
            }
            await this.fetch();
        },

        methods: {
            async fetch() {
                try {
                    const { data: description } = await Vue.axios.get(`/entity-additional-description/${ this.entityType }/${ this.entityId }/${ this.categoryId }`);
                    if(description.id) {
                        this.description = {
                            ...this.description,
                            ...description
                        }
                    } else {
                        this.description = {
                            ...this.description,
                            text: '',
                            blocks: [],
                            enabled: true
                        }
                    }
                    if(!this.description.blocks) {
                        this.description.blocks = [];
                    }
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${error.response.data.error}`);
                }
            },
            addBlock() {
                this.description.blocks.push({
                    type: 'main',
                    title: '',
                    opened: false,
                    list: []
                });
            },
            removeBlock(index) {
                this.description.blocks.splice(index, 1);
            },
            addBlockLine(index) {
                this.description.blocks[index].list.push({
                    title: '',
                    text: '',
                    price: '',
                    question: '',
                    answer: '',
                    opened: false
                });
            },
            removeBlockLine(index, lindex) {
                this.description.blocks[index].list.splice(lindex, 1);
            },

            async save() {
                if(this.description.id) {
                    await Vue.axios.put(`/entity-additional-description/${this.description.id}`, this.description);
                } else {
                    await Vue.axios.post('/entity-additional-description/', this.description);
                }
                this.goBack();
            },

            async remove() {
                if(this.description.id) {
                    await Vue.axios.delete(`/entity-additional-description/${this.description.id}`);
                }
                this.goBack();
            },

            goBack() {
                this.$router.push('.');
            }
        },
    };
</script>